// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import PrimaryErrorMessage from './PrimaryErrorMessage';

// Constants
import { SERVICE_STATUS_URL } from '../../../../common/utils/urlConstants';

const getErrorMessage = (primaryError) => {
    if (primaryError?.isNetworkError) {
        return (
            <span>
                We couldn&apos;t connect to the Milanote servers.
                <br />
                Check the{' '}
                <a href={SERVICE_STATUS_URL} target="_blank" rel="noopener noreferrer">
                    status page
                </a>
                &nbsp;on our website for updates.
            </span>
        );
    }

    if (!primaryError?.message || primaryError.status === 500) {
        return (
            <span>
                Sorry, something went wrong. Please try again or check the{' '}
                <a href={SERVICE_STATUS_URL} target="_blank" rel="noopener noreferrer">
                    status page
                </a>{' '}
                if you continue to have problems.
            </span>
        );
    }

    return primaryError.message;
};

const AuthErrorMessage = (props) => {
    const { primaryError, hide } = props;

    return <PrimaryErrorMessage message={getErrorMessage(primaryError)} show={!hide && !!primaryError} />;
};

AuthErrorMessage.propTypes = {
    primaryError: PropTypes.object,
    hide: PropTypes.bool,
};

export default AuthErrorMessage;
